var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-icon"},[_c('icon-frame',{attrs:{"icon-name":_vm.getIcon(_vm.deviceType),"icon-type":_vm.getIconType(_vm.deviceType),"icon-color":_vm.getIconColor(_vm.isColorized)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }